import config from 'config';
import Vue from 'vue';
export const AgeConfirmation = {
  name: 'AgeConfirmation',
  computed: {
    isProduct () {
      return this.$store.getters['user/getOrderAgeConfirmation']
    },
    urlLink () {
      return this.$store.getters['user/getUrlLink']
    }
  },
  methods: {
    async confirm (value) {
      // get cookie term for age restriction from config  (for example, values can be like: for days - 14D, for hours - 2h)
      let cookieTerm = config.restrictions.userAgePassedCookieTerm;
      if (!cookieTerm) {
        cookieTerm = '14D'        // set 14 days by default
      }

      // if userAgePassed = false set cookie term
      value ? Vue.$cookies.set('userAgePassed', value) : Vue.$cookies.set('userAgePassed', value, cookieTerm)

      this.$bus.$emit('modal-hide', 'modal-age-confirm');
      if (value) {
        await this.$store.dispatch('cart/addItem', { productToAdd: this.isProduct })
        this.$forceUpdate();
        this.notifyUser({
          type: 'success',
          message: this.$t('Product has been added to the cart!'),
          action1: { label: this.$t('OK') },
          action2: null
        })
      } else {
        this.notifyUser({
          type: 'error',
          message: this.$t('To buy this product your age should be 18 or higher!'),
          action1: { label: this.$t('OK') },
          action2: null
        })
      }
    },
    notifyUser (notificationData) {
      this.$store.dispatch('notification/spawnNotification', notificationData, { root: true })
    }
  }
}
